import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cs from 'classnames';
import { useFormikContext } from 'formik';
import React from 'react';
import { DragHandle } from 'components/ui/DragHandle/DragHandle';
import { AchievementRow, AchievementRowProps } from '../AchievementRow/AchievementRow';
import { AchievementRowGamePass } from '../AchievementRow/AchievementRowGamePass';
import { IAchievementModal } from '../AchievementsModalTypes';
import { isGamePassAchievement } from '../utils';

interface AchievementRowSortableProps extends AchievementRowProps {
  id: number | string;
  isLocked?: boolean;
}

export function AchievementRowSortable(props: AchievementRowSortableProps) {
  const {
    id,
    isLocked = false,
    index,
    ...rest
  } = props;

  const { values } = useFormikContext<IAchievementModal[]>();
  const achievement = values[index];
  const isGamePass = achievement && isGamePassAchievement(achievement);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled: isLocked || isGamePass,
    transition: {
      duration: 500,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    backgroundColor: 'white',
    transform: (isLocked || isGamePass) ? undefined : CSS.Transform.toString(transform),
    borderBottom: '2px dotted black',
    marginBottom: '1rem',
    transition: (isLocked || isGamePass) ? undefined : transition,
    boxShadow: (isDragging && !isLocked && !isGamePass)
      ? '-1px 0 15px 0 rgba(34, 33, 81, 0.01), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)'
      : undefined,
    opacity: (isLocked || isGamePass) ? 0.8 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cs('d-flex position-relative', isDragging && 'sort-item')}
    >
      {(isLocked || isGamePass) ? (
        <span
          style={{
            width: '100%',
            maxWidth: '20px',
            opacity: 0.3,
          }}
          title={isGamePass ? 'GamePass achievement' : 'This achievement is locked in position'}
        >
          {isGamePass ? '🎮' : '🔒'}
        </span>
      ) : (
        <DragHandle
          attributes={attributes}
          listeners={listeners}
        />
      )}
      {isGamePass ? (
        <AchievementRowGamePass
          index={index}
        />
      ) : (
        <AchievementRow
          index={index}
          confirmDelete={rest.confirmDelete}
        />
      )}
    </div>
  );
}
